// Keep only an incident correlation token, never headers, payloads or URLs.
export function checkoutDispatchFailure(error) {
  const response = error?.response || error;
  if (
    response?.status !== 404 ||
    response?.data?.message?.trim?.().toLowerCase() !== 'service not found'
  )
    return null;
  const candidate =
    response.data.request_id ||
    response.data.data?.request_id ||
    response.headers?.['x-request-id'];
  return {
    code: 'checkout_dispatch_failure',
    ...(typeof candidate === 'string' &&
    /^[a-zA-Z0-9_-]{1,128}$/.test(candidate)
      ? { requestId: candidate }
      : {}),
  };
}

export const dispatchFailureMessage = (details) =>
  `Checkout status is temporarily unavailable. Your checkout is kept; retry its status before paying.${
    details?.requestId ? ` Reference: ${details.requestId}` : ''
  }`;

export function checkoutStatusError(error, fallback) {
  const details = checkoutDispatchFailure(error);
  if (details)
    return Object.assign(new Error(dispatchFailureMessage(details)), details);
  if (error?.code === 'checkout_dispatch_failure') return error;
  return new Error(fallback);
}
